export default __webpack_public_path__ + "static/media/ico_personal.338cdcc3.svg";